import { create } from 'zustand'

interface ModalPortalTerrenoState {
  modalPortalTerreno: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalPortalTerreno: (modalPortalTerreno: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalPortalTerreno: {
    isOpen: false
  }
}

export const useModalPortalTerrenoStore = create<ModalPortalTerrenoState>()(
  (set) => ({
    ...initialState,
    setModalPortalTerreno: (modalPortalTerreno) => set({ modalPortalTerreno }),
    reset: () =>
      set({
        modalPortalTerreno: initialState.modalPortalTerreno
      })
  })
)
